var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container",style:(_vm.styleObj)},[_c('img',{attrs:{"src":require("@/assets/images/empty.png"),"alt":""}}),_c('span',[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }